module.exports = __webpack_public_path__ + "dfe1f0a80f177357b6e8ada9f1b337a4.pdf";